import { render } from "./About_home.vue?vue&type=template&id=123a6938&scoped=true"
import script from "./About_home.vue?vue&type=script&lang=js"
export * from "./About_home.vue?vue&type=script&lang=js"

import "./About_home.vue?vue&type=style&index=0&id=123a6938&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123a6938"]])

export default __exports__